import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ScrollToTop from './component/scrollToTop/ScrollToTop';
import CorporateAgency from './pages/CorporateAgency';
import ServicePage from './pages/ServicePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import { ThemeProvider } from './context/ThemeContext';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/app.scss';

const AppContent = () => {
  const { i18n } = useTranslation();

  const language = i18n.language || 'en';

  useEffect(() => {
    if (typeof document === 'undefined') {
      return;
    }

    const dir = i18n.dir(language);

    document.documentElement.lang = language;
    document.documentElement.dir = dir;
    document.body.classList.toggle('rtl', dir === 'rtl');
  }, [i18n, language]);

  return (
    <Routes>
      <Route path="/" element={<CorporateAgency />} />
      <Route path="/service/:slug" element={<ServicePage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfUse />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App = () => (
  <ThemeProvider>
    <ScrollToTop />
    <AppContent />
  </ThemeProvider>
);

export default App;
